export const languages = [
    { short: "en", full: "English" },
    { short: "ru", full: "русский" },
]

export const uiStrings = {
    'who_plays_first':
    {
        en: "Who makes the first move?",
        ru: 'Кто сделает первый ход?',
    },
    'user_begins':
    {   
        en: 'Me',
        ru: 'Я',        
    },
    'opponent_begins':
    {
        en: 'My opponent',
        ru: 'Противник',
    },  


};

